import * as Yup from "yup";

const addLeadershipInitialValues = {
  backgroundImage: "",
};
const addLeadershipValidationSchema = Yup.object().shape({
  backgroundImage: Yup.string().trim().required("Image is required*"),
});
export { addLeadershipInitialValues, addLeadershipValidationSchema };
